export default __webpack_public_path__ + "static/media/AnimalGame_08.5d4afbeb.png";